<div class="chart-wrapper" #wrapper>
  <canvas #chartCanvas [attr.id]="canvasId"></canvas>
</div>